import { useEffect } from 'react';
import mux from 'mux-embed';

type ObserverProps = {
  videoRef?: Node,
  videoAnalyticsData?: {
    duration: number,
    userId?: string,
    videoTitle: string,
    videoId: string,
    playerName: string,
    isLive: boolean,
    videoViewId?: string
  },
};

const videoObserver = ({ videoRef, videoAnalyticsData, duration, videoViewId, hls, Hls } : ObserverProps) => {
  useEffect(() => {
    if (videoRef) {
      const hasHls = hls ? {
        hlsjs: hls,
        Hls,
      } : {};
      
      const initTime = mux.utils.now();
      mux.monitor(videoRef, {
        debug: false,
        disableCookies: true,
        ...hasHls,
        data: {
          env_key: process.env.ACARA_DEPLOY_ENV === 'production' ? 'vib38hjvc215b31khbl900d23' : process.env.ACARA_DEPLOY_ENV === 'staging' ? 'f06nsq3ggb0ksqhnloag75ag1' : 'nnn034uurhvub6jmlrmfi1cq6', // dev key for now
          player_name: videoAnalyticsData.playerName, 
          player_init_time: initTime,
          viewer_user_id: videoAnalyticsData.userId || `anonymousView-${videoViewId}`, 
          // Video Metadata
          video_id: videoAnalyticsData.videoId, 
          video_title: videoAnalyticsData.videoTitle,
          video_duration: videoAnalyticsData.duration, // in milliseconds, ex: 120000
          video_stream_type: videoAnalyticsData.isLive ? 'live' : 'on-demand', // 'live' or 'on-demand'
        }
      });
    }
  }, [videoRef, duration, hls, Hls]);

  return null // component does not render anything
}

export default videoObserver;